<template>
	<div>
		<div class="footer-copyright">
			<div class="menu">
				<template v-for="(aboutus,index) in aboutusList">
					<a :href="aboutus.url">{{aboutus.title}}</a>
					<template v-if="index!=(aboutusList.length-1)">|</template>
				</template>
			</div>
			<div>
				Copyright © 2017 All Rights Reserved baomate.com
				<span id="site_stat"></span>
			</div>
		</div>
		<!--底部 结束-->
	</div>
</template>

<script>
	import { getAboutUsUrl,cmsApiUrl } from "../../static/js/emallUtils.js"
	export default {
		name: 'footercopyright',
		data() {
			return {
				aboutUsUrl: '',
				aboutusList:[]
			}
		},
		methods: {
			requestCms: function(req_param) {
				var that = this;
				var params = {
					c: req_param
				};
				jQuery.ajax({
					type: "get",
					url: cmsApiUrl,
					async: false,
					dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
					cache: true,
					data: params,
					success: function(ret) {
						if(ret.code == 'success') {
							var list = ret.values.list;
							if(list != undefined && list.length > 0) {
								that.aboutusList = list;
							}
						}
					},
					error: function(err) {

					}
				})
			}
		},
		mounted() {
			this.aboutUsUrl = getAboutUsUrl();
			this.requestCms("aboutus");
			/**
			 * 站长统计
			 */
			var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
			jQuery("#site_stat").html(unescape("%3Cspan id='cnzz_stat_icon_1276729368'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s23.cnzz.com/z_stat.php%3Fid%3D1276729368%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/FooterCopyright.vue